// import { integrationClientChannelId } from '../axios-client';
import axios from 'axios';
import {
  B2B_BUILDERTREND_LINK_PATH,
  B2B_BUILDERTREND_UNLINK_PATH,
} from '../../constants/paths';
import { getBuildertrendAxiosClient } from '../axios-client';
import { getSvocId, getUserId } from '../../utils/user';

const userId = getUserId() ?? '';
const svocId = getSvocId() ?? ''; // Temporary until we have a way to get svocId in this file. Will be replaced with actual svocId once that is available.

/**
 *
 * @param code - is passed from parent function which does the actual call.
 * @returns promise api
 */
export const BuildertrendLinkApi = (code: string) => {
  return axios
    .create({
      ...getBuildertrendAxiosClient(code),
      responseType: 'json',
    })
    .post(B2B_BUILDERTREND_LINK_PATH(userId, svocId));
};

/**
 *
 * export const integrationClientChannelId = {
  client: axios.create({ ...integrationClientBase, responseType: 'json' }),
};

 */
export const BuildertrendUnlinkApi = (userType: 'customer' | 'user') => {
  return axios
    .create({
      ...getBuildertrendAxiosClient(''),
      responseType: 'json',
    })
    .delete(
      `${B2B_BUILDERTREND_UNLINK_PATH(userId, svocId)}?requestType=${
        userType || 'user'
      }`,
    );
};
